import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  changeAllCategory,
  changeAllCategoryLanding,
  changeCategoryPage,
  changeCateTags,
  changeProductTags
} from '@/store/slices/categoryPageSlice';
import {
  getAllCategory,
  getAllCategoryLanding,
  getCategoryPage,
  getCateTags,
  getProductTags
} from '@/services/category';
import { SearchReq } from '@/type/pages';

export const getCategoryPageAction = createAsyncThunk(
  'categoryPage/getCategoryPageAction',
  async (requestData: SearchReq, { dispatch }) => {
    const { data } = await getCategoryPage(requestData);
    if (!data) return { isSuccess: false };
    await dispatch(changeCategoryPage(data));
    return { isSuccess: true };
  }
)

export const getAllCategoryAction = createAsyncThunk(
  'categoryPage/getAllCategoryAction',
  async (localLanguage: string, { dispatch }) => {
    const { data } = await getAllCategory(localLanguage);
    await dispatch(changeAllCategory(data?.[0] || []));
    return data?.[0] || []; // optional: return value for fulfilled action
  },
);


export const getAllCategoryLandingAction = createAsyncThunk(
  'categoryPage/getAllCategoryLandingAction',
  async (localLanguage: string, { dispatch }) => {
    const { data } = await getAllCategoryLanding(localLanguage);
    await dispatch(changeAllCategoryLanding(data[0] || []));
  }
)

// Get Tags Action
export const getCateTagsAction = createAsyncThunk(
  'categoryPage/getCateTags',
  async (language: string, { dispatch }) => {
    const resCateTags = await getCateTags(language);
    const result = Object.entries(resCateTags?.data)?.map(([title, topics]) => ({ title, topics }));
    await dispatch(changeCateTags(result));
  }
)

export const getProductTagsAction = createAsyncThunk(
  'categoryPage/getProductTags',
  async (language: string, { dispatch }) => {
    const resProductTags = await getProductTags(language);
    await dispatch(changeProductTags(resProductTags?.data?.[0] || []));
  }
)


